import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { Paso5pagePageRoutingModule } from './paso5page-routing.module';

import { Paso5pagePage } from './paso5page.page';
import {ModalHerramientasYControlesPageModule} from '../modal-herramientas-ycontroles/modal-herramientas-ycontroles.module'
import {MiscomponentesModule} from '../miscomponentes/componentes.module'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    Paso5pagePageRoutingModule,
    ModalHerramientasYControlesPageModule,
    MiscomponentesModule
  ],
  declarations: [
    Paso5pagePage,

  ]
})
export class Paso5pagePageModule {}
